import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SlideOver } from "@/components/ui/slide-over";
import type { InterpretationResponse } from "@/types/interpretation.types";
import { useCreateRunInterpretation } from "./hooks";
import { InterpretationBody } from "./InterpretationBody";

// Botão "Interpretar" numa rodada (sem chat): cria a interpretação (só fatos) e
// abre o overlay. Erro (ex.: simulação não concluída) cai no toast amigável global (MutationCache).
// Reusável nas telas de resultado; o overlay leva à página completa (histórico + deep-link).

export function InterpretRunButton({
  simulationId,
  disabled,
}: {
  simulationId: string;
  disabled?: boolean;
}): React.ReactElement {
  const navigate = useNavigate();
  const [result, setResult] = useState<InterpretationResponse | null>(null);
  const create = useCreateRunInterpretation(simulationId);

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        disabled={disabled || create.isPending}
        onClick={() => create.mutate(undefined, { onSuccess: (r) => setResult(r) })}
      >
        <Sparkles className="mr-1.5 h-4 w-4" aria-hidden />
        {create.isPending ? "Interpretando…" : "Interpretar"}
      </Button>

      <SlideOver
        open={result != null}
        onOpenChange={(o) => !o && setResult(null)}
        title="Interpretação da simulação"
        width={540}
      >
        {result ? (
          <>
            <InterpretationBody data={result} />
            <div className="border-t border-border-subtle px-5 py-3">
              <Button
                variant="ghost"
                size="sm"
                onClick={() =>
                  navigate(`/simulations/${simulationId}/interpretations/${result.id}`)
                }
              >
                Abrir página completa e histórico
              </Button>
            </div>
          </>
        ) : null}
      </SlideOver>
    </>
  );
}
